import type { Step } from '@/components/wizard/Step';

import type { AzureRestoreAccountState } from './azureConnectRestoreWizard';
import { ConnectAzureRestoreAccount } from './connectAzureRestoreAccount';

export const AzureConnectRestoreFlow: Step<AzureRestoreAccountState> = {
  id: 'connect_restore_subscription',
  Component: ConnectAzureRestoreAccount,
  nonReturnable: false,
};
